import React from 'react';
import Svg from '../Svg';
import { SvgProps } from '../types';

const Icon: React.FC<SvgProps> = props => (
  <Svg viewBox="0 0 24 21" {...props}>
    <path d="M22.8099 0.635254C23.4166 0.635254 23.9172 1.08922 23.9907 1.67598L23.9999 1.82525V19.6752C23.9999 20.2819 23.546 20.7825 22.9592 20.856L22.8099 20.8652H1.38995C0.783287 20.8652 0.282654 20.4113 0.209223 19.8245L0.199951 19.6752V1.82525C0.199951 1.21859 0.653918 0.717957 1.24068 0.644526L1.38995 0.635254H22.8099ZM22.8099 1.82525H1.38995V19.6752H22.8099V1.82525ZM17.7603 11.8411V14.0227H11.1566V17.2952L6.26098 12.578C6.0906 12.4138 6.08557 12.1426 6.24974 11.9722C6.33049 11.8884 6.44186 11.8411 6.55823 11.8411H17.7603ZM13.0433 4.20525L17.9389 8.92253C18.1093 9.0867 18.1143 9.3579 17.9501 9.52827C17.8694 9.61207 17.758 9.65942 17.6417 9.65942H6.43962V7.47775H13.0433V4.20525Z" />
  </Svg>
);

export default Icon;
